// import axios from 'axios';
// import { Message } from 'element-ui';
// import router from '@/router'
// import store from '../store';
// import { getToken, setToken } from '@/utils/auth';
import { getToken } from '@/utils/auth';
// import { getTokens } from '@/api/login'
import Cookies from 'js-cookie'
import Api from './request.config'

// 创建axios实例
// eslint-disable-next-line
const service = axios.create({
  baseURL: Api, // api的base_url
  timeout: 20000                 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(config => {
  if (config.url.split('/').pop() === 'login') {
    config.headers['X-Cookie'] = Cookies.get('cookies');
  }
  // 如果token过期，cookie中还是存在token的，仍会带上x-authorization;(一般的请求都不会是'/login',所以让是请求login的不能进入)
  if (/* store.getters.token */getToken() && config.url.split('/').pop() !== 'login') {
    config.headers['X-Authorization'] = 'Bearer ' + getToken(); // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
  }
  return config;
}, error => {
  // Do something with request error
  console.log(error); // for debug
  Promise.reject(error);
})

// respone拦截器
service.interceptors.response.use(
  response => response.data,
  error => {
    console.log(error);
    if ((error + '').indexOf('401') > -1) {
      // 关于userInfo已在main.js中做401处理,操作中token失效的话，可以再次请求token,执行之前的请求，但是页面的loading等展示需要根据error判断
      /* getTokens().then((res)=>{
        setToken(res.token);debugger
      }).then(()=>{
        service(error.config);debugger
      }); */
    }
    return Promise.reject(error);
  }
)

export default service;



// WEBPACK FOOTER //
// ./src/utils/fetch.js